import KktComponent from "@/components/api/KktComponent";
import {handleApiError} from "@/utils/VuexUtil";

const MODULE_NAME = 'kkt'

const state = {
    isLoading: false,
    errors: null,
    result: null,
}

export const KktActionTypeEnum = {
    get: '['+MODULE_NAME+'] get',
    list: '['+MODULE_NAME+'] list',
    add: '['+MODULE_NAME+'] add',
    upd: '['+MODULE_NAME+'] upd'
};

const MutationTypeEnum = {
    getStart: '['+MODULE_NAME+'] getStart',
    getSuccess: '['+MODULE_NAME+'] getSuccess',
    getFailure: '['+MODULE_NAME+'] getFailure',

    listStart: '['+MODULE_NAME+'] listStart',
    listSuccess: '['+MODULE_NAME+'] listSuccess',
    listFailure: '['+MODULE_NAME+'] listFailure',

    addStart: '['+MODULE_NAME+'] addStart',
    addSuccess: '['+MODULE_NAME+'] addSuccess',
    addFailure: '['+MODULE_NAME+'] addFailure',

    updStart: '['+MODULE_NAME+'] updStart',
    updSuccess: '['+MODULE_NAME+'] updSuccess',
    updFailure: '['+MODULE_NAME+'] updFailure',
};

const getters = {
    kktIsLoading: (state) => state.isLoading,
    kktGetResult: (state) => state.result,
    kktGetErrors : (state) => state.errors
}

const mutations =  {
    // Get
    [MutationTypeEnum.getStart](state) {
        state.isLoading = true
        state.result = null
        state.errors = null
    },
    [MutationTypeEnum.getSuccess](state, response) {
        state.isLoading = false
        if (response) state.result = response.result
    },
    [MutationTypeEnum.getFailure](state, response) {
        state.isLoading = false
        if (response) state.errors = response.errors
    },

    // List
    [MutationTypeEnum.listStart](state) {
        state.isLoading = true
        state.result = null
        state.errors = null
    },
    [MutationTypeEnum.listSuccess](state, response) {
        state.isLoading = false
        if (response)state.result = response.result
    },
    [MutationTypeEnum.listFailure](state, response) {
        state.isLoading = false
        if (response) state.errors = response.errors
    },

    // Add
    [MutationTypeEnum.addStart](state) {
        state.isLoading = true
        state.result = null
        state.errors = null
    },
    [MutationTypeEnum.addSuccess](state, response) {
        state.isLoading = false
        if (response) state.result = response.result
    },
    [MutationTypeEnum.addFailure](state, response) {
        state.isLoading = false
        if (response) state.errors = response.errors
    },

    // Upd
    [MutationTypeEnum.updStart](state) {
        state.isLoading = true
        state.result = null
        state.errors = null
    },
    [MutationTypeEnum.updSuccess](state, response) {
        state.isLoading = false
        if (response) state.result = response.result
    },
    [MutationTypeEnum.updFailure](state, response) {
        state.isLoading = false
        if (response) state.errors = response.errors
    }
}

const actions = {
    async [KktActionTypeEnum.get](context, request) {
        context.commit(MutationTypeEnum.getStart)
        try {
            const response = await KktComponent.get(request);
            context.commit(MutationTypeEnum.getSuccess, response);
            return response;
        } catch (error) {
            const formattedError = handleApiError(error);
            context.commit(MutationTypeEnum.getFailure, formattedError);
            return formattedError;
        }
    },

    async [KktActionTypeEnum.list](context, request) {
        context.commit(MutationTypeEnum.listStart)
        try {
            const  response = await KktComponent.list(request)
            context.commit(MutationTypeEnum.listSuccess, response)
            return response
        } catch (error) {
            const formattedError = handleApiError(error);
            context.commit(MutationTypeEnum.listFailure, formattedError);
            return formattedError;
        }
    },

    async [KktActionTypeEnum.add](context, request) {
        context.commit(MutationTypeEnum.addStart)
        try {
            const response = await KktComponent.add(request);
            context.commit(MutationTypeEnum.addSuccess, response);
            return response;
        } catch (error) {
            const formattedError = handleApiError(error);
            context.commit(MutationTypeEnum.addFailure, formattedError);
            return formattedError;
        }
    },

    async [KktActionTypeEnum.upd](context, request) {
        context.commit(MutationTypeEnum.updStart)
        try {
            const response = await KktComponent.upd(request);
            context.commit(MutationTypeEnum.updSuccess, response);
            return response;
        } catch (error) {
            const formattedError = handleApiError(error);
            context.commit(MutationTypeEnum.updFailure, formattedError)
            return formattedError;
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}